<template>
    <section v-if="pageLoader">
        <div class="page-loader">
            {{ $t("loading.loading") }}
        </div>
    </section>
    <section v-else-if="userIsEmpty('user')">
        <div class="no-auth">
            {{ $t("auth.noAuth") }}
            <router-link class="link" tag="a" :to="{ name: 'home' }">
                {{ $t("auth.noAuthLink") }}</router-link>
        </div>
    </section>
    <section v-else-if="!profileIsEmpty('profile')" class="friends friends-profile">
        <h1 class="heading">
            <div class="container-mobile container-mobile-row">
                <router-link :to="'/profile/' + id" class="heading-back"></router-link>
                <span>{{ $t("profile.friends") }} ({{ profile.first_name }}
                    {{ profile.last_name }})</span>
            </div>
        </h1>
        <div class="info-block container-mobile">
            <div class="friends-search">
                <input v-model="search" @input="getSearch" @change="getSearch" type="text" class="input"
                    :placeholder="$t('threads.search')" />
            </div>
            <div class="friends-block">
                <ul v-if="!friendsIsEmpty('friends')" class="friends-list friends-all user-list">
                    <li v-for="(friend, index) in friends" :ref="'element' + index" :key="index"
                        class="friends-item user-item" :class="{
                            online: friend.online,
                        }">
                        <router-link :to="'/profile/' + friend.id" :style="{
                            'background-image': friend.avatar
                                ? 'url(' + friend.avatar + ')'
                                : '',
                        }" class="user-item-avatar" :class="{
    'no-avatar': !friend.avatar,
}"></router-link>
                        <div class="user-item-info">
                            <router-link :to="'/profile/' + friend.id" class="user-item-title">{{ friend.name
                            }}</router-link>
                            <div v-if="friend.city" class="user-item-subtitle">
                                {{ friend.city }}
                            </div>
                        </div>
                    </li>
                    <li v-if="moreLoader"><button class="button-loader"></button></li>
                </ul>
                <div v-else>
                    <span v-if="search.length < 3">{{
                        $t("myFriends.friendsEmpty")
                    }}</span>
                    <span v-else>{{ $t("myFriends.noUsersQuery") }}</span>
                </div>
            </div>
        </div>
    </section>
    <section v-else-if="isBlacklist">
        <div class="no-auth">{{ $t("auth.userRestrictedPage") }}</div>
    </section>
    <section v-else>
        <div class="no-auth">{{ $t("auth.wasAnError") }}</div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
    name: "Friends",
    props: {
        i18n: Object,
    },
    components: {},
    mixins: [observeListEnd],
    data() {
        return {
            id: null,
            pageLoader: true,
            localFriends: {},
            searchFriends: {},
            search: "",
            isSearch: false,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            profile: "profile/fetchProfile",
            profileIsEmpty: "profile/isEmpty",
            profileErrors: "profile/errors",
            isBlacklist: "profile/fetchIsBlacklist",
            friends: "friends/fetchFriends",
            friendsIsEmpty: "friends/isEmpty",
            friendsCount: "friends/fetchFriendsCount",
            friendsNext: "friends/fetchFriendsNext",
        }),
    },
    created() {
        this.id = this.$route.params.id;
        if (this.id == this.user.id) {
            this.$router.push({
                name: "my_friends",
            });
        }
        this.get();
        this.getProfile();
    },
    methods: {
        get(query = false) {
            let self = this;
            this.observer = new IntersectionObserver(
                function (entries) {
                    if (entries[0].isIntersecting === true) {
                        self.showMore();
                    }
                },
                { threshold: [0] }
            );

            this.$store
                .dispatch("friends/profileGet", [this.id, query])
                .then(() => {
                    this.pageLoader = false;
                    this.isSearch = query ? true : false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        getSearch() {
            if (this.search.length >= 3) {
                this.get(encodeURIComponent(this.search));
            } else if (this.isSearch) {
                this.get();
            }
        },
        getProfile() {
            this.$store
                .dispatch("profile/get", this.id)
                .then(() => { })
                .catch(() => { });
        },
        updateMoreIndex() {
            this.moreIndex = this.friends.length - 2;
        },
        showMore() {
            if (this.friendsNext) {
                this.moreLoader = true;
                this.$store
                    .dispatch("friends/getNext")
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
    },
};
</script>

<style lang="scss">
@import "~@/assets/styles/pages/_friends";
</style>
